import { Directive, HostListener, Input } from '@angular/core';
import { EventsService } from '@shared/services';
import { HubService } from 'src/app/bar/services/hub.service';

@Directive({
  selector: '[clickTrackLocation]',
})
export class ClickTrackLocationDirective {
  @Input() clickTrackLocation: string;
  @Input() dynamicFields: any;

  constructor(private eventsService: EventsService, public hubService: HubService) {}
  @HostListener('click')
  onClick() {
    if (typeof this.clickTrackLocation === 'string') {
      const location: string = this.hubService.currentLocation;
      this.eventsService.event(this.clickTrackLocation, {
        location: { title: location },
        ...this.dynamicFields,
      });
    }
  }
}
